module.exports = __webpack_public_path__ + "img/13step-03-01-1_ergebnis.ee96130e.png";